import Task from "../../model2/task/task";
// @ts-ignore
const modalDependencyInfo = () => import(/* webpackChunkName: "modals-dependency" */ 'core/gd-modals/dependency/dependency-info/modal-dependency-info.jsx');
// @ts-ignore
const modalAddTaskDependency = () => import(/* webpackChunkName: "modals-dependency" */ 'core/gd-modals/dependency/task-dependency/task-dependency-modal.jsx');

const debug = false
// const debug = "DependencyModalsManager"

export default class ModalsDependency {

    dependencyInfo(dependencyInfo: any, dependencyId:ID|null=null, onEditLag: callback|null=null, onRemove: callback|null=null, isReadOnly: boolean) {

        gd.modal.loadAndShow(modalDependencyInfo, false, {
            className: 'modal-dependency-info',
            modalType: 'v4',
            toggleCallback: (isOpen: boolean) => {
                // console.log("toggle")
            },
            params: {
                dependencyInfo  : dependencyInfo,
                dependencyId    : dependencyId, // is used to load data from db
                isReadOnly,
                onEditLagCallback: (successorId: ID, newRange: any)=>{
                    if (onEditLag) onEditLag(successorId, newRange)
                },
                onRemoveCallback: (predecessorId: ID, successorId: ID, type: any)=>{
                    gd.modal.hide()
                    if (onRemove) onRemove(predecessorId, successorId, type)
                },
                onFinishCallback: ()=>{
                    gd.modal.hide();
                }
            }
        });

    }

    addTaskDependency(task:Task, dependsOn:any, dependentTasks: any, dependencyType:any, callback:callback|undefined) {

        gd.modal.loadAndShow(modalAddTaskDependency, false, {
            className: 'modal-task-dependency',
            modalType: 'v4',
            toggleCallback: (isOpen: boolean) => {
                // console.log("toggle")
            },
            params: {
                taskId: task.id,
                parentProjectId: task.projectId,
                dependencyType,
                dependsOn,
                dependentTasks,
                onSubmit: (type: any, task1Id: ID, task2Id:ID)=>{
                    if (callback) callback(type, task1Id, task2Id);
                    gd.modal.hide();
                },
            }
        });
    }

}